import { render } from "./splash.vue?vue&type=template&id=7d770121&scoped=true"
const script = {}

import "./splash.vue?vue&type=style&index=0&id=7d770121&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d770121"]])

export default __exports__